import { FormInputProps } from "../../models/form.model";
import React from "react";
import { Controller } from "react-hook-form";
import { FormControlLabel, FormHelperText, Stack, Switch } from "@mui/material";

export default function FormSwitch(props: FormInputProps) {
  const { name, control, label, rules, setError, helperText } = props;
  const setErrorMsg = (message: string) => {
    setError(name, { type: "manual", message });
  };
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, value = false },
        fieldState: { error },
        formState,
      }) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <FormControlLabel
            control={
              <Switch
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
              />
            }
            label={label || ""}
          />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </Stack>
      )}
    />
  );
}
